<template>
  <div
    class="page-index"
    v-pageBuried
    data-page-buried="BG_TIZHIPINGGU_FENGMIAN"
  >
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <img
      class="top-title"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/babc5a7a14f5b74b7817c5d3a24aa0ae.png"
      alt=""
    />
    <div class="p-content">
      <img
        class="p-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/14235c6deb4f1f4c915297a9e786f243.png"
        alt=""
      />
      <div class="p-line"></div>
      <div class="wenhao iconfont icon-wenhao4"></div>
      <div class="p-list">
        <img
          :id="'p-image-' + index"
          class="p-image-item"
          :class="{ 'p-image-animate': item.animate }"
          v-for="(item, index) in imageList"
          :key="index"
          :src="item.url"
          :style="item.classObj"
          @click="bindClick(item)"
        />
      </div>
    </div>
    <div class="desc"
      >共<span class="bold">17</span>道专业的生活化问题，约需<span class="bold"
        >3</span
      >分钟完成</div
    >
    <div class="btn" @click="bindQuestion"
      ><span>开始评估</span><span class="iconfont icon-xiala"></span
    ></div>
    <img
      class="logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
      alt=""
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageList: [
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/438ff7a109db6c5d1f0f5648b0213fec.png',
          disabled: false,
          animate: false,
          left: -31,
          top: -21,
          classObj: {}
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/152bb233d0e817caea74e4e297f765af.png',
          disabled: false,
          animate: false,
          left: 173,
          top: 50,
          classObj: {}
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fbf3483d8aeca85864a4a051fff108dd.png',
          disabled: false,
          animate: false,
          left: -21,
          top: 100,
          classObj: {}
        },
        {
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f0dc13015b9599b9a68ad542002ba20a.png',
          disabled: false,
          animate: false,
          left: 200,
          top: 159,
          classObj: {}
        }
      ]
    }
  },
  created() {
    this.getExistsNewcomerQue()
  },
  mounted() {
    this.init()
  },
  methods: {
    getExistsNewcomerQue() {
      this.$http
        .getBaseApp('member/AppCamp/getExistsNewcomerQue', {
          rid: this.$route.query.id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data) {
              this.$dialog
                .confirm({
                  title: '提示',
                  message: '你已填写问卷,是否查看结果？'
                })
                .then(() => {
                  // on confirm
                  this.$router.replace({
                    path: '/newcomer-questionnaire-v2/result',
                    query: {
                      id: this.$route.query.id
                    }
                  })
                })
                .catch(() => {
                  // on cancel
                })
            }
          }
        })
    },
    bindQuestion() {
      this.$router.replace({
        path: '/newcomer-questionnaire-v2/question',
        query: {
          id: this.$route.query.id
        }
      })
    },
    bindClose() {
      this.$http.appBack()
    },
    init() {
      let designWidth = 375
      let delay = 0.5 //延迟0.5s
      let duration = 0.3 //多个气泡之间的时间间隔
      this.imageList.map((item, index) => {
        item.classObj = {
          left: (item.left * window.screen.width) / designWidth + 'px',
          top: (item.top * window.screen.width) / designWidth + 'px',
          animationDelay: delay + duration * index + 's'
        }
        this.bindPlay(item)
      })
    },
    bindPlay(item) {
      item.animate = true
      setTimeout(() => {
        item.animate = false
        item.disabled = false
      }, 1300 + parseFloat(item.classObj.animationDelay) * 1000)
    },
    bindClick(item) {
      if (item.disabled) {
        return
      }
      item.classObj.animationDelay = '0s'
      item.disabled = true
      this.bindPlay(item)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-index {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d0e71e0c3f1d1c9697fece596b0ba776.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  overflow: hidden;

  .close {
    padding: 4px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.3);
    top: 60px;
    left: 20px;
    position: absolute;
  }

  .top-title {
    margin: 12.5vh auto 50px;
    width: 327px;
    height: 136px;
    object-fit: contain;
  }

  .p-content {
    position: relative;
    margin: 0 auto 40px;
    width: 262px;
    height: 332px;

    .p-line {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      width: 270px;
      height: 53px;
      bottom: 0;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 2px,
        rgba(255, 255, 255, 0.7) 3px,
        rgba(255, 255, 255, 0) 100%
      );
      animation: lineAnimate 4s linear infinite;
    }

    .p-image {
      width: 100%;
      height: 100%;
    }

    .wenhao {
      position: absolute;
      color: #fff;
      left: 140px;
      top: 16px;
      width: 30px;
      height: 40px;
      transform-origin: center bottom;
      /*   animation: myRotate 5s linear infinite; */
    }

    .p-list {
      .p-image-item {
        height: 64px;
        object-fit: contain;
        position: absolute;
      }

      .p-image-animate {
        animation: myHeart 1.3s ease-in-out;
      }
    }
  }

  .desc {
    text-align: center;
    margin-bottom: 14px;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(13, 13, 13, 0.6);
    line-height: 18px;

    .bold {
      font-size: 13px;
      font-family: DINPro-Bold, DINPro;
      font-weight: bold;
      color: #0d0d0d;
      background-color: rgba(255, 254, 135, 1);
    }
  }

  .btn {
    margin: 0 auto;
    text-align: center;
    width: 270px;
    height: 48px;
    line-height: 48px;
    background: #0d0d0d;
    box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.11);
    border-radius: 26px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 20px;
    animation: myScale 1.6s linear infinite;
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      width: 26px;
      height: 26px;
      font-size: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;
      transform: rotate(-90deg);
    }
  }

  .logo {
    margin: 0 auto 66px;
    width: 58px;
    height: 10px;
    object-fit: contain;
  }
}

@keyframes myScale {
  0% {
    transform: scale(0.95) translateY(-4px);
  }

  50% {
    transform: scale(1.05) translateY(0px);
  }

  100% {
    transform: scale(0.95) translateY(-4px);
  }
}

@keyframes myHeart {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.15);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.15);
  }

  70% {
    transform: scale(1);
  }
}

@keyframes myRotate {
  0% {
    transform: rotate(-20deg);
  }

  4% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(30deg);
  }

  19% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-20deg);
  }

  30% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-20deg);
  }
}

@keyframes lineAnimate {
  0% {
    bottom: 0px;
  }

  100% {
    bottom: 279px;
  }
}
</style>
